<template>
  <div class="container mt-5 mb-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow-lg p-4">
          <h2 class="text-center mb-4 text-primary">
            <i class="fa fa-user-plus me-2"></i>{{ $t("register.title") }}
          </h2>

          <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
          <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

          <form @submit.prevent="register">
            <!-- Username -->
            <div class="mb-3">
              <label for="username" class="form-label">
                <i class="fa fa-user me-2"></i>{{ $t("register.username") }}
              </label>
              <input id="username" type="text" class="form-control" v-model="username" required />
            </div>

            <!-- Email -->
            <div class="mb-3">
              <label for="email_cont" class="form-label">
                <i class="fa fa-envelope me-2"></i>{{ $t("register.email") }}
              </label>
              <input id="email_cont" type="email" class="form-control" v-model="email_cont" required />
            </div>

            <!-- Confirm Email -->
            <div class="mb-3">
              <label for="confirm_email" class="form-label">
                <i class="fa fa-envelope me-2"></i>{{ $t("register.confirmEmail") }}
              </label>
              <input id="confirm_email" type="email" class="form-control" v-model="confirmEmail" required />
              <div v-if="emailError" class="text-danger mt-2">{{ $t("register.emailMismatch") }}</div>
            </div>

            <!-- Password -->
            <div class="mb-3">
              <label for="password" class="form-label">
                <i class="fa fa-lock me-2"></i>{{ $t("register.password") }}
              </label>
              <input id="password" type="password" class="form-control" v-model="password" required />
              <div v-if="passwordError" class="text-danger mt-2">{{ $t("register.passwordRequirements") }}</div>
            </div>

            <!-- Confirm Password -->
            <div class="mb-3">
              <label for="confirm_password" class="form-label">
                <i class="fa fa-lock me-2"></i>{{ $t("register.confirmPassword") }}
              </label>
              <input id="confirm_password" type="password" class="form-control" v-model="confirmPassword" required />
              <div v-if="passwordMismatch" class="text-danger mt-2">{{ $t("register.passwordMismatch") }}</div>
            </div>

            <!-- Checkbox Termeni si Politica -->
<!-- Checkbox Termeni si Politica -->
<div class="mb-4 form-check text-start">
  <input 
    id="acceptTerms" 
    type="checkbox" 
    class="form-check-input" 
    v-model="acceptTerms" 
    required 
  />
  <label class="form-check-label" for="acceptTerms">
    {{ $t("register.acceptTermsStart") }}
    <router-link to="/termeni" target="_blank" class="text-primary">{{ $t("register.termsLink") }}</router-link> 
    {{ $t("register.acceptTermsMiddle") }}
    <router-link to="/politica" target="_blank" class="text-primary">{{ $t("register.policyLink") }}</router-link>{{ $t("register.acceptTermsEnd") }}
  </label>
  <div v-if="termsError" class="text-danger mt-1">
    {{ $t("register.termsError") }}
  </div>
</div>

            <button type="submit" class="btn btn-success w-100">
              <i class="fa fa-user-plus me-2"></i>{{ $t("register.button") }}
            </button>
          </form>

          <div class="text-center mt-3">
            <p>
              {{ $t("register.alreadyAccount") }}
              <router-link to="/login" class="register-link"><i class="fa fa-sign-in me-2"></i>{{ $t("register.loginLink") }}</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ClientSignUp",
  data() {
    return {
      username: "",
      email_cont: "",
      confirmEmail: "",
      password: "",
      confirmPassword: "",
      acceptTerms: false, // <-- adăugat
      errorMessage: "",
      successMessage: "",
      emailError: false,
      passwordError: false,
      passwordMismatch: false,
      termsError: false, // <-- adăugat
    };
  },
  methods: {
    validatePassword(password) {
      // Validăm ca parola să aibă minim 6 caractere, o cifră și un semn special
      const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{6,}$/;
      return regex.test(password);
    },
    async register() {
      // Resetăm mesajele de eroare personalizate
      this.emailError = false;
      this.passwordError = false;
      this.passwordMismatch = false;
      this.termsError = false;

      // Verificăm dacă toate câmpurile necesare sunt completate
      if (!this.username || !this.email_cont || !this.password || !this.confirmPassword) {
        this.errorMessage = this.$t("register.validation");
        return;
      }

      // Verificăm dacă a bifat termenii
      if (!this.acceptTerms) {
        this.termsError = true;
        return;
      }

      // Verificăm dacă emailurile corespund
      if (this.email_cont !== this.confirmEmail) {
        this.emailError = true;
        return;
      }

      // Validăm parola
      if (!this.validatePassword(this.password)) {
        this.passwordError = true;
        return;
      }

      // Verificăm dacă parolele coincid
      if (this.password !== this.confirmPassword) {
        this.passwordMismatch = true;
        return;
      }

      const requestData = {
        username: this.username.trim(),
        email_cont: this.email_cont.trim(),
        password: this.password.trim(),
      };

      try {
        await axios.post("https://api.feribot-eurobac.ro/client/api/register/", requestData, {
          headers: { "Content-Type": "application/json" },
        });

        this.successMessage = this.$t("register.success");
        this.clearForm();

        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } catch (error) {
        this.errorMessage = error.response?.data?.error || this.$t("register.serverError");
      }
    },
    clearForm() {
      this.username = "";
      this.email_cont = "";
      this.confirmEmail = "";
      this.password = "";
      this.confirmPassword = "";
      this.acceptTerms = false; // <-- resetat
      this.emailError = false;
      this.passwordError = false;
      this.passwordMismatch = false;
      this.termsError = false; // <-- resetat
      this.errorMessage = "";
    },
  },
};
</script>